export const formatPhone = (value: string): string => {
  const numbersOnly = value.replace(/\D/g, "");

  if (numbersOnly.startsWith("55") && numbersOnly.length <= 13) {
    return numbersOnly
      .replace(/^(\d{2})(\d{2})(\d)/, "+$1 ($2) $3")
      .replace(/(\d{4})(\d)/, "$1-$2");
  } else if (numbersOnly.length <= 11) {
    const withCountryCode = "55" + numbersOnly;
    return withCountryCode
      .replace(/^(\d{2})(\d{2})(\d)/, "+$1 ($2) $3")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
  return value;
};

export const formatCpf = (value: string): string => {
  const numbersOnly = value.replace(/\D/g, "");
  if (numbersOnly.length <= 11) {
    return numbersOnly
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1-$2");
  }
  return value;
};

// Fonte única de CNPJ (alfanumérico): formatação e validação vêm de utils.
export {
  formatCnpj,
  isValidCnpj,
  cleanCnpj,
} from "../../../../../utils/format-utils";

export const isValidCpf = (cpf: string): boolean => {
  const numbersOnly = cpf.replace(/\D/g, "");
  return numbersOnly.length === 11;
};

export const isValidPhone = (phone: string): boolean => {
  const numbersOnly = phone.replace(/\D/g, "");
  return (
    (numbersOnly.length >= 10 && numbersOnly.length <= 11) ||
    (numbersOnly.startsWith("55") &&
      numbersOnly.length >= 12 &&
      numbersOnly.length <= 13)
  );
};

export const formatCurrency = (value: number | null | undefined): string => {
  if (!value && value !== 0) return "R$ 0,00";
  const valueInReais = value / 100;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valueInReais);
};

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return "-";
  return dateString.substring(0, 10).split("-").reverse().join("/");
};
